import { ReactElement } from 'react';

import { Combobox, ComboboxProps } from '../combobox';
import { Popover, type PopoverProps } from '../popover';

import styles from './dropdown.module.scss';

export const Dropdown = (props: DropdownProps) => {
  const { onOpen, trigger, onClose, popoverProps } = props;

  return (
    <Popover
      {...popoverProps}
      onOpen={onOpen}
      onClose={onClose}
      className={styles.dropdown}
      onContentClick={(e) => e.preventDefault()}
      content={({ context }) => <Combobox {...props} context={context} />}
    >
      {trigger}
    </Popover>
  );
};

export interface DropdownProps extends Omit<ComboboxProps, 'context'> {
  onClose?: () => void;
  onOpen?: () => void;
  trigger?: ReactElement;
  popoverProps?: Partial<PopoverProps>;
}
